import { Box, Container, Typography, Grid, Link as MuiLink, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import logo from "../logo/Legalcastlegroupnbg.png";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#081524",
        color: "#F8FBFF",
        pt: 8,
        pb: 3,
        mt: "auto",
        background: "linear-gradient(160deg, #081524 0%, #0D2139 100%)",
        borderTop: "none",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Atmospheric glow */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(ellipse 60% 40% at 20% 80%, rgba(70,130,180,0.04) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />

      <Container maxWidth="xl" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={4}>
          {/* Column 1: About */}
          <Grid size={{ xs: 12, md: 3 }}>
            <Box sx={{ mb: 2 }}>
              <img
                src={logo}
                alt="Legal Castle Group"
                style={{ height: "60px", filter: "brightness(0) invert(1)", marginBottom: "16px" }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: "rgba(176,196,222,0.75)",
                  lineHeight: 1.8,
                  mb: 2,
                  fontWeight: 300,
                }}
              >
                Experienced legal counsel for intellectual property protection and business law.
                Serving clients with dedication and expertise since inception.
              </Typography>
              <Typography
                sx={{
                  fontFamily: '"Cinzel", serif',
                  fontSize: "8px",
                  letterSpacing: "0.18em",
                  textTransform: "uppercase",
                  color: "rgba(176,196,222,0.5)",
                }}
              >
                Licensed in India &bull; Bar Certified
              </Typography>
            </Box>
          </Grid>

          {/* Column 2: Practice Areas */}
          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Typography
              sx={{
                fontFamily: '"Cinzel", serif',
                fontSize: "9px",
                letterSpacing: "0.2em",
                textTransform: "uppercase",
                color: "rgba(176,196,222,0.6)",
                mb: 2.5,
                display: "flex",
                alignItems: "center",
                gap: 1,
                "&::before": {
                  content: '""',
                  width: 16,
                  height: 1,
                  background: "rgba(70,130,180,0.3)",
                },
              }}
            >
              Practice Areas
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
              {[
                { label: "Intellectual Property", path: "/practice-areas/intellectual-property" },
                { label: "Business Law", path: "/practice-areas/business-law" },
                { label: "Banking Law", path: "/practice-areas/banking-law" },
                { label: "Litigation", path: "/practice-areas/litigation" },
              ].map((link) => (
                <MuiLink
                  key={link.path}
                  component={Link}
                  to={link.path}
                  sx={{
                    color: "rgba(176,196,222,0.7)",
                    textDecoration: "none",
                    fontSize: "0.85rem",
                    fontWeight: 300,
                    transition: "all 0.3s ease",
                    "&:hover": { color: "#B0C4DE" },
                  }}
                >
                  {link.label}
                </MuiLink>
              ))}
            </Box>
          </Grid>

          {/* Column 3: Company */}
          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Typography
              sx={{
                fontFamily: '"Cinzel", serif',
                fontSize: "9px",
                letterSpacing: "0.2em",
                textTransform: "uppercase",
                color: "rgba(176,196,222,0.6)",
                mb: 2.5,
                display: "flex",
                alignItems: "center",
                gap: 1,
                "&::before": {
                  content: '""',
                  width: 16,
                  height: 1,
                  background: "rgba(70,130,180,0.3)",
                },
              }}
            >
              Company
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
              {[
                { label: "About Us", path: "/#about" },
                { label: "Our Team", path: "/#team" },
                { label: "Contact", path: "/contact" },
              ].map((link) => (
                <MuiLink
                  key={link.path}
                  component={Link}
                  to={link.path}
                  sx={{
                    color: "rgba(176,196,222,0.7)",
                    textDecoration: "none",
                    fontSize: "0.85rem",
                    fontWeight: 300,
                    transition: "all 0.3s ease",
                    "&:hover": { color: "#B0C4DE" },
                  }}
                >
                  {link.label}
                </MuiLink>
              ))}
            </Box>
          </Grid>

          {/* Column 4: Contact Info */}
          <Grid size={{ xs: 12, md: 5 }}>
            <Typography
              sx={{
                fontFamily: '"Cinzel", serif',
                fontSize: "9px",
                letterSpacing: "0.2em",
                textTransform: "uppercase",
                color: "rgba(176,196,222,0.6)",
                mb: 2.5,
                display: "flex",
                alignItems: "center",
                gap: 1,
                "&::before": {
                  content: '""',
                  width: 16,
                  height: 1,
                  background: "rgba(70,130,180,0.3)",
                },
              }}
            >
              Contact
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.8 }}>
              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "linear-gradient(135deg, rgba(70,130,180,0.12), rgba(70,130,180,0.04))",
                    border: "1px solid rgba(70,130,180,0.15)",
                    flexShrink: 0,
                  }}
                >
                  <LocationOnIcon sx={{ fontSize: 16, color: "#4682B4" }} />
                </Box>
                <Typography variant="body2" sx={{ color: "rgba(176,196,222,0.7)", lineHeight: 1.7, fontWeight: 300 }}>
                  1 A Vansittart Row, Damodar House<br />
                  Ground Floor, (WB) PIN Code 700001
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "linear-gradient(135deg, rgba(70,130,180,0.12), rgba(70,130,180,0.04))",
                    border: "1px solid rgba(70,130,180,0.15)",
                    flexShrink: 0,
                  }}
                >
                  <PhoneIcon sx={{ fontSize: 16, color: "#4682B4" }} />
                </Box>
                <MuiLink
                  href="tel:+918961103239"
                  sx={{
                    color: "rgba(176,196,222,0.7)",
                    textDecoration: "none",
                    fontSize: "0.85rem",
                    fontWeight: 300,
                    "&:hover": { color: "#B0C4DE" },
                  }}
                >
                  +91 8961103239
                </MuiLink>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "linear-gradient(135deg, rgba(70,130,180,0.12), rgba(70,130,180,0.04))",
                    border: "1px solid rgba(70,130,180,0.15)",
                    flexShrink: 0,
                  }}
                >
                  <EmailIcon sx={{ fontSize: 16, color: "#4682B4" }} />
                </Box>
                <Box>
                  <MuiLink
                    href="mailto:info@legalcastlegroup.com"
                    sx={{
                      color: "rgba(176,196,222,0.7)",
                      textDecoration: "none",
                      fontSize: "0.85rem",
                      fontWeight: 300,
                      "&:hover": { color: "#B0C4DE" },
                    }}
                  >
                    info@legalcastlegroup.com
                  </MuiLink>
                  {", "}
                  <MuiLink
                    href="mailto:ck@legalcastle.com"
                    sx={{
                      color: "rgba(176,196,222,0.7)",
                      textDecoration: "none",
                      fontSize: "0.85rem",
                      fontWeight: 300,
                      "&:hover": { color: "#B0C4DE" },
                    }}
                  >
                    ck@legalcastle.com
                  </MuiLink>
                </Box>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "linear-gradient(135deg, rgba(70,130,180,0.12), rgba(70,130,180,0.04))",
                    border: "1px solid rgba(70,130,180,0.15)",
                    flexShrink: 0,
                  }}
                >
                  <AccessTimeIcon sx={{ fontSize: 16, color: "#4682B4" }} />
                </Box>
                <Typography variant="body2" sx={{ color: "rgba(176,196,222,0.7)", fontWeight: 300 }}>
                  Monday - Friday: 9:00 AM - 6:00 PM
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 5, borderColor: "rgba(70,130,180,0.08)" }} />

        {/* Legal Disclaimer */}
        <Box sx={{ mb: 3 }}>
          <Typography
            sx={{
              fontFamily: '"Cinzel", serif',
              fontSize: "8px",
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              color: "rgba(176,196,222,0.45)",
              mb: 1,
            }}
          >
            Legal Disclaimer
          </Typography>
          <Typography
            variant="caption"
            sx={{
              display: "block",
              color: "rgba(176,196,222,0.55)",
              lineHeight: 1.7,
              fontSize: "0.75rem",
              fontWeight: 300,
            }}
          >
            The information on this website is for general information purposes only.
            Nothing on this site should be taken as legal advice for any individual case or situation.
            This information is not intended to create, and receipt or viewing does not constitute, an attorney-client relationship.
          </Typography>
        </Box>

        {/* Bottom Bar */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
            pt: 2,
            borderTop: "1px solid rgba(70,130,180,0.08)",
          }}
        >
          <Typography
            sx={{
              fontFamily: '"Cinzel", serif',
              fontSize: "8px",
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              color: "rgba(176,196,222,0.5)",
            }}
          >
            &copy; {new Date().getFullYear()} Legal Castle Group. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
